import React from 'react'
import SubAdmin from '../masterLayout/SubAdmin'
import Breadcrumb from '../components/Breadcrumb'
import ManagerViewProfile from '../components/child/ManagerViewProfile'

export const Managerprofile = () => {
  return (
    <SubAdmin>
    <Breadcrumb title="Manager Profile" />
    <ManagerViewProfile />

    </SubAdmin>

)
}
